module.exports = __webpack_public_path__ + "img/backgroundImageDiplomaDefault.b903e98.PNG";